import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

/** Named checklists in the settings (owner remark 3/20). */
export const PRESETS_RESOURCE = 'planning.checklist_presets';
export const PRESETS_KEY = ['planning', 'checklist-presets'] as const;

export type ChecklistPreset = { id: string; name: string; items: string[]; version: number };

export function usePresets(enabled = true) {
  return useQuery({ queryKey: PRESETS_KEY, enabled, retry: false, queryFn: () => api<{ presets: ChecklistPreset[] }>('/api/planning/checklist-presets') });
}

/** Text area → points: one per line, trimmed, empty lines dropped. */
export const pointsOf = (text: string): string[] => text.split('\n').map((l) => l.trim()).filter((l) => l !== '');

/** "3 punkty", "1 punkt", "5 punktów". */
export function pointsLabel(n: number): string {
  const word = n === 1 ? 'punkt' : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'punkty' : 'punktów';
  return `${n} ${word}`;
}
